var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tag",class:{ 'tag--value-number': typeof _vm.tagValue == 'number' }},[_c('span',{staticClass:"tag__name"},[_vm._v(" "+_vm._s(_vm.tagName)+" ")]),_c('span',{staticClass:"tag__value"},[_vm._v(" "+_vm._s(_vm.tagValue)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }